import { useState } from "react";
import { User } from "lucide-react";

export default function ProfileImage({ imageUrl, className = '' }) {
    const [error, setError] = useState(false);

    if (!imageUrl || error) {
        return (
            <div className="w-40 h-20 rounded bg-gray-200 flex items-center justify-center">
                <User className="w-40 h-20 text-gray-500" />
            </div>
        );
    }

    return (
        <img
            src={imageUrl}
            alt="Profile"
            className={`w-40 h-20 rounded object-cover inline-block ${className}`}
            onError={() => setError(true)}
        />
    );
}
